export const lang = {
  nav: {
    title: 'Mina sidor',
    customer: 'Start',
    subscriptions: 'Abonnemang',
    invoices: 'Fakturor',
    changePassword: 'Byt lösenord',
    login: 'Logga in',
    logout: 'Logga ut',
  },
  customer: {
    title: 'Välkommen till Mina sidor!',
    intro:
      'Här hittar du information, kan se dina fakturor och har möjlighet att administrera dina abonnemang.',
    invoices: 'Senaste fakturor',
    address: 'Leveransadress',
    invoiceAddress: 'Fakturaadress',
    addressTitle: 'Dina adresser',
    addressInfo: 'Info',
    addressTypeHeader: 'Typ',
    addressHeader: 'Adress',
    contactName: 'Kontaktperson',
    emailAddress: 'E-post',
    phoneNumber: 'Telefonnummer',
    careOf: 'c/o',
    addressLine1: 'Adress',
    postCode: 'Postnummer',
    area: 'Postort',
    customerNumber: 'Kundnummer',
    edit: {
      title: 'Ändra kontaktuppgifter',
      intro:
        'Skriv in dina nya kontaktuppgifter för att ändra dina uppgifter hos oss.',
      button: 'Ändra kontaktuppgifter',
      loading: 'Ändrar kontaktuppgifter...',
    },
    verify: {
      title: 'Verifiera kontaktuppgifter',
      intro:
        'För att logga in på Mina sidor behöver du bekräfta dina kontaktuppgifter.',
      confirm: 'Jag bekräftar att uppgifterna stämmer.',
      button: 'Bekräfta kontaktuppgifter',
      loading: 'Bekräftar kontaktuppgifter...',
    },
    addresses: {
      edit: {
        title: 'Ändra adressuppgifter',
        intro:
          'Skriv in din nya adress och välj vilka tidigare adresser som ska ersättas.',
        important:
          'Viktigt! Om du har ett fastnätsnummer som ska flyttas behöver du göra en flyttanmälan här på hemsidan eller kontakta kundservice så hjälper vi dig med det.',
        button: 'Ändra adressupgifter',
        loading: 'Ändrar uppgifter...',
        from: 'Gäller från och med',
        currentAddresses: 'Nuvarande adresser',
        newAddress: 'Ny adress',
      },
    },
    tasks: {
      addressChange: 'Adressändring till {0} kommer gälla från och med {1}.',
    },
  },
  subscription: {
    title: 'Dina abonnemang',
    monthlyFee: 'Månadsavgift',
    variableFee: 'Rörlig avgift',
    additionalFee: 'Förhöjd avgift',
    contractLength: 'Bindningstid',
    endDate: 'Bundet till',
    freeMonthsEndDate: 'Fria månader till',
    loading: 'Laddar dina abonnemang...',
    tasks: {
      conversion:
        'Det här abonnemanget kommer att byta abbonemangsform till {0} från och med {1}.',
      termination: 'Det här abonnemanget kommer att avslutas {0}.',
      numberChange:
        'Det här abonnemanget kommer att byta nummer till {0} från och med {1}.',
      transfer:
        'Det här abonnemanget kommer att överlåtas till {0} ({1}) från och med {2}.',
      dataPackage: 'Nytt datapaket från {0} ({1}).',
      outPorting: 'vid utflytt till annan operatör',
    },
    customerNumber: 'Kundnummer',
    vatInfo0: 'Samtliga priser anges exklusive moms',
    vatInfo1: 'Samtliga priser anges inklusive moms',
    noActiveSubscriptions: 'Du har inga aktiva abonnemang.   ',
  },
  simCard: {
    title: 'SIM-kort',
    iccId: 'SIM-kortsnummer',
    pinCode: 'PIN-kod',
    pukCode: 'PUK-kod',
    pinNote: 'Denna gäller endast om du själv inte ändrat din PIN-kod.',
    order: 'Beställ nytt SIM-kort',
    orderExtra: 'Beställ extra SIM-kort',
    activeOrder: 'Nytt SIM-kort beställt {0}',
    activeExtraOrder: 'Extra SIM-kort beställt {0}',
    activate: {
      title: 'Aktivera nytt SIM-kort',
      intro: 'Aktivera ditt nya SIM-kort nu. Det gamla kommer sluta fungera.',
      button: 'Aktivera nytt SIM-kort',
      loading: 'Aktiverar nytt SIM-kort...',
      cancel: 'Avbryt',
    },
    printPinLetter: 'Skriv ut PIN-brev',
    dialog: {
      title: 'Beställ nytt SIM-kort',
      intro: 'Välj ett av nedan alternativ för att beställa ett nytt SIM-kort.',
      activation: 'Aktiveras',
      direct: 'Direkt',
      manual: 'Manuellt',
      date: 'Vid tidpunkt',
      important1:
        '- Genom att göra SIM-kortsbyte godkänner du en kostnad på {0} som kommer på din nästkommande faktura.',
      important2:
        '- Vid aktivering av nytt SIM-kort kommer det gamla SIM-kortet sluta fungera.',
      button: 'Beställ nytt SIM-kort',
      loading: 'Beställer nytt SIM-kort...',
      tooltip: {
        direct: 'Ditt nya SIM-kort aktiveras direkt vid utskick.',
        manual:
          'Du aktiverar SIM-kortet själv via Mina sidor alternativt kontaktar Kundservice.',
        date: 'Välj den tid du önskar att ditt nya SIM-kort ska aktiveras.',
      },
    },
    extraDialog: {
      title: 'Beställ extra SIM-kort',
      intro:
        'Välj ett av nedan alternativ för att beställa ett extra SIM-kort.',
      activation: 'Aktiveras',
      direct: 'Direkt',
      date: 'Vid tidpunkt',
      important:
        'Genom att beställa extra SIM-kort godkänner du en tillkommande månadskostnad på {0}.',
      button: 'Beställ extra SIM-kort',
      loading: 'Beställer extra SIM-kort...',
      tooltip: {
        direct: 'Ditt extra SIM-kort aktiveras direkt vid utskick.',
        date: 'Välj den tid du önskar att ditt extra SIM-kort ska aktiveras.',
      },
    },
  },
  barring: {
    title: 'Spärra tjänster',
    info: 'Du kan spärra ditt abonnemang eller tjänster för att undvika extra kostnader vid stöld eller förlust av din telefon. Du kan när som helst välja att spärra upp abonnemanget här på Mina sidor eller genom att kontakta kundservice.',
    important:
      'Jag är medveten om att min telefon kommer att spärras för samtliga in- och utgående samtal och datatrafik.',
    confirm:
      'Vänligen bekräfta att du vill spärra tjänsten. Du kan när som helst spärra upp det igen.',
    tooltips: {
      barSubscription:
        'Du kan inte ta bort spärren, var vänlig kontakta kundtjänst.',
      barData:
        'Du kan inte spärra mobildata eftersom du har ett aktivt datapaket.',
    },
    dialog: {
      cancel: 'Avbryt',
      intro: 'Är du säker på att du vill {0} {1}?',
      activate: 'Aktivera',
      deactivate: 'Inaktivera',
      important:
        'För att tjänsten ska fungera efter du har inaktiverat spärren kan du kan behöva starta om telefonen.',
    },
  },
  dataPackage: {
    title: 'Datapaket',
    used: 'Använt',
    remaining: 'Kvar',
    current: 'Nuvarande datapaket',
    notAvailable:
      'Kunde inte ladda förbrukning på grund av att datapaketet är av en gammal typ, kontakta kundservice vid frågor.',
    usage: 'Förbrukning',
    resetDate: 'Surfvolymen återställs om {0} dagar ({1})',
    dialog: {
      title: 'Byt datapaket',
      current: 'Ditt nuvarande datapaket är',
      activate: 'Aktiveras',
      direct: 'Direkt',
      date: 'Vid tidpunkt',
    },
    topUp: {
      title: 'Beställ extra surf',
      intro: 'Välj surfmängd för att fylla på din surf.',
      important:
        'Din extra surf räcker endast kalendermånaden ut. Efter det gäller din vanliga surfmängd igen.',
    },
    hasOrdered:
      'Extra surf är nu aktiverat. Det kan dröja ett par minuter innan du kan se den nya förbrukningen.',
  },
  networkServices: {
    title: 'Aktivera tjänster',
    dialog: {
      activate: 'Aktivera',
      deactivate: 'Inaktivera',
      intro: 'Är du säker på att du vill {0} {1}?',
      cancel: 'Avbryt',
    },
  },
  invoices: {
    title: 'Fakturor',
    loading: 'Hämtar dina fakturor...',
    intro: 'Här visas dina fakturor för de senaste 12 månaderna.',
    invoiceNumber: 'Fakturanr',
    customerNumber: 'Kundnr',
    date: 'Datum',
    amount: 'Belopp',
    paid: 'Betald',
    showAll: 'Visa mer...',
  },
  login: {
    title: 'Logga in på Mina sidor',
    intro: 'Logga in med det användarnamn och det lösenord som skickats ut.',
    orgNumber: 'Användarnamn',
    password: 'Lösenord',
    button: 'Logga in',
    loading: 'Loggar in...',
    resetPassword: 'Glömt lösenord?',
    loginError: 'Felaktiga inloggningsuppgifter. Vänligen försök igen.',
    welcomeText:
      'Välkommen till "Mina sidor" på ETC Mobil – din personliga plats där du enkelt kan hålla koll på ditt/dina abonnemang, se användning och hantera inställningar med bara några klick.',
    welcomeHeading: 'Med ETC Mobil-appen kan du få ännu bättre koll! Du hittar den där appar finns.',
    welcomeHeadingLink: '',
    welcomeText2:
      'Med appen får du tillgång till alla funktioner från "Mina sidor" och mycket mer – allt för att göra din mobilanvändning så enkel och bekymmersfri som möjligt. Finns det något bättre ställe att hantera ditt mobilabonnemang – än i mobilen?',
    // welcomeHeading2: 'Varför ETC Mobil-appen?',
    // welcomeListItemHeading: 'Snabb överblick:',
    // welcomeListItem:
    //   'Få en snabb översikt över ditt nuvarande abonnemang och användning.',
    // welcomeListItemHeading2: 'Enklare hantering: ',
    // welcomeListItem2:
    //   'Ändra ditt abonnemang, köp tilläggstjänster och få support på ett ögonblick.',
    // welcomeListItemHeading3: 'Exklusiva erbjudanden:',
    // welcomeListItem3:
    //   'Tillgång till specialerbjudanden och tjänster som endast finns tillgängliga via appen',
  },
  resetPassword: {
    title: 'Glömt lösenord',
    intro:
      'Skriv in ditt  person- eller organisationsnummer så kommer ett nytt lösenord skickas till dig.',
    orgNumber: 'Person-/Organisationsnummer',
    button: 'Skicka nytt lösenord',
    loading: 'Skickar nytt lösenord...',
    notFoundError:
      'Felaktigt person-/organisationsnummer. Vänligen försök igen.',
    notVerifiedError:
      'Vi saknar bekräftade kontaktuppgifter till dig. Vänligen kontakta kundservice.',
    successMessage:
      'Ett nytt lösenord har skickats till den e-postadress som är registrerad hos oss.',
  },
  changePassword: {
    title: 'Byt lösenord',
    intro:
      'Skriv in ditt nuvarande lösenord och välj ett nytt lösenord för att byta lösenord till Mina sidor.',
    oldPassword: 'Nuvarande lösenord',
    newPassword: 'Välj nytt lösenord',
    confirmPassword: 'Bekräfta nytt lösenord',
    button: 'Byt lösenord',
    loading: 'Byter lösenord...',
    networkError: 'Ett fel uppstod. Kontrollera lösenordet och försök igen.',
    oldPasswordError: 'Vänligen ange nuvarande lösenord.',
    newPasswordError: 'Vänligen välj nytt lösenord.',
    confirmPasswordError: 'Vänligen bekräfta nytt lösenord.',
    mismatchError: 'Bekräftelsen matchar inte det nya lösenordet.',
    successMessage: 'Ditt lösenord har ändrats!',
  },
  error: {
    title: 'Ett oväntat fel uppstod',
    description:
      'Vänligen försök igen eller kontakta kundservice om felet kvarstår.',
    close: 'Stäng',
  },
  maintenance: {
    title: 'Underhåll pågår',
    description:
      'Just nu pågår underhåll på våra system. Vänligen försök igen lite senare.',
    close: 'Stäng',
  },
  progress: {
    title: 'Genomför ändringar',
    description: 'Vänligen vänta medan ändringarna genomförs...',
  },
}
